import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    uuid: String,
    interval: { type: Number, default: 5000 },
    mediaType: String,
  }

  declare uuidValue: string
  declare intervalValue: number
  declare mediaTypeValue: string

  private timer: number | null = null
  private request: AbortController | null = null

  connect(): void {
    this.poll()
  }

  disconnect(): void {
    this.stop()
  }

  private poll(): void {
    this.timer = window.setInterval(() => {
      this.checkStatus()
    }, this.intervalValue)
  }

  private stop(): void {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    this.request?.abort()
    this.request = null
  }

  private async checkStatus(): Promise<void> {
    if (this.request) return

    const request = new AbortController()
    this.request = request
    const requestTimeout = window.setTimeout(() => request.abort(), 15000)
    try {
      const response = await fetch(`/api/v2/detect/${this.uuidValue}`, { signal: request.signal })
      if (!response.ok || request.signal.aborted) return

      const data = await response.json()
      // Labels can already exist while watermark/intelligence analysis is still
      // pending. Only the API's overall status accounts for every requested step.
      if (!request.signal.aborted && data.success && ['completed', 'failed'].includes(data.item?.status)) {
        this.stop()
        this.reloadReport()
      }
    } catch (error) {
      if (!request.signal.aborted) {
        console.error('Error polling detect status:', error)
      }
    } finally {
      window.clearTimeout(requestTimeout)
      if (this.request === request) this.request = null
    }
  }

  protected reloadReport(): void {
    window.location.reload()
  }
}
